module.exports = __webpack_public_path__ + "static/media/logo-badge.0026b862.svg";